import {Button, Grid, Typography} from "@mui/material";

const Boton_Crear_Proyecto = () => {
    return (
        <Grid container
            justifyContent={'center'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}>
            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{xs: 12, sm: 10, md: 10}} sx={{pt: 20,}}>
                <Grid
                    container size={{xs: 12, sm: 12, md:12}}
                    sx={{maxWidth: '14000px', px: 3}}>
                    <Grid container
                          size={{xs: 12, sm: 12, md: 12}} sx={{}}>
                        <Grid container size={{xs: 12, sm: 6, md: 6}}>
                            <Typography>
                                Nombre
                            </Typography>
                        </Grid>


                        <Grid container justifyContent={'flex-end'} alignItems={'center'}
                              alignItems={'center'} size={{xs: 12, sm: 6, md: 6}}>
                            <Button href={'/dashboard/proyectos/crear'}>
                                Crear
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}
export default Boton_Crear_Proyecto;

